import { useEffect, useState } from 'react';

export const useScreenShake = () => {
  const [isShaking, setIsShaking] = useState(false);

  const shake = (duration: number = 300) => {
    setIsShaking(true);
    setTimeout(() => setIsShaking(false), duration);
  };

  useEffect(() => {
    if (!isShaking) return;

    const element = document.body;
    element.style.animation = 'shake 0.3s ease-in-out';

    const timer = setTimeout(() => {
      element.style.animation = '';
    }, 300);

    return () => {
      clearTimeout(timer);
      element.style.animation = '';
    };
  }, [isShaking]);

  return { shake, isShaking };
};
